import { render, staticRenderFns } from "./DataDiscoveryTable.vue?vue&type=template&id=617db01e&"
import script from "./DataDiscoveryTable.vue?vue&type=script&lang=js&"
export * from "./DataDiscoveryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports